/**
 * Hides a declared directional light from three's render through its layers, and hands them back.
 * R3F owns the light's `visible` and its `castShadow`, so the fitter leaves both alone. A light that
 * fails the camera's layer test never enters the render's light list (r187 `WebGLRenderer.js:1877-1891`),
 * while its children still do.
 */
import { freeShadowMap } from './shadowMapAllocation.js';
/**
 * Each hidden light's own layer mask. Written only by `hideLight`. An entry clears when `showLight`
 * hands the mask back.
 */
// eslint-disable-next-line no-restricted-syntax -- hideLight writes an entry and showLight deletes it
const ownMasks = new WeakMap();
/** Takes the light off every layer. A second call keeps the mask the first one saved. */
export function hideLight(light) {
    if (ownMasks.has(light))
        return;
    ownMasks.set(light, light.layers.mask);
    light.layers.disableAll();
    // The hidden light draws no shadow, so a map it drew before only holds memory.
    freeShadowMap(light.shadow);
}
/** Puts a hidden light back on its own layers. A light never hidden stays as it is. */
export function showLight(light) {
    const mask = ownMasks.get(light);
    if (mask === undefined)
        return;
    ownMasks.delete(light);
    light.layers.mask = mask;
}
/** The layers the light renders on when it is not hidden. */
export function ownLayerMask(light) {
    return ownMasks.get(light) ?? light.layers.mask;
}
//# sourceMappingURL=hiddenLight.js.map